/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { FC, useEffect, useState, useRef } from "react"; // Importe tudo o que precisa
import {
  DefaultProvider,
  sha256,
  toHex,
  bsv,
} from "./scrypt-ts-this/distthis/index";
import './styles/App.css';
import { ViewTokenDataStyle } from "./styles/ViewTokenDataStyle";

import {
  getSpentOutput,
  getTransaction,
  scriptHistory,
} from "./webservice/mProviders";
import { RetContentType } from "./webservice/OrdinalsContentType";
import {
  hexToLittleEndian,
} from "./webservice/myUtils";
import { fileTypeFromData, hexToBytes } from "./webservice/myUtils";
import { Box, TextField, Typography } from "@mui/material";
import { CustomButton } from "./components/CustomButton";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { compState, homenetwork, homepvtKey} from './Headerr';


interface props1 {
  passedData: string;
}

const ViewTokenData: FC<props1> = (props) => {
  const { t } = useTranslation();

  const { txidParams } = useParams<{ txidParams?: string }>();
  const { netParams } = useParams<{ netParams?: string }>();
  const [currentTxid, setcurrentTxid] = useState("");

  const [fileType, setfileType] = useState("bin");

  const [txStamp, settxStamp] = useState("");

  const [downloadFile, setdownloadFile] = useState(false);

  const [waitAlert, setwaitAlert] = useState(
    t('viewtoken.waitingInit')
  );

  const [txb, settxb] = useState(true);

  const [binaryData, setbinaryData] = useState<Uint8Array>(new Uint8Array());
  const [strData, setstrData] = useState("");
  const [tokenInfo, settokenInfo] = useState("");
  const [tokenOwner, settokenOwner] = useState("");
  const [tokenSale, settokenSale] = useState("");

  const [binaryDataTX, setbinaryDataTX] = useState<Uint8Array>(
    new Uint8Array()
  );
  const [hexStrFileData, setHexString] = useState(""); // Inicialmente vazia

  const [txidFlag, settxidFlag] = useState("");

  // Estas variáveis dependem de `binaryData` e devem ser re-calculadas no render
  // ou em um `useEffect` secundário.
  // Evite declará-las no escopo superior do componente se elas dependem de estados mutáveis,
  // pois isso pode não refletir o estado mais recente.
  // Mova-as para dentro do `return` ou para um `useEffect` que depende de `binaryData`.
  // Por agora, vou deixá-las aqui mas esteja ciente disso para bugs futuros de visualização.
  const [imageUrl, setImageUrl] = useState("");
  const [htmlDataP, setHtmlDataP] = useState("");
  const [videoUrl, setVideoUrl] = useState("");


  let txIdRet = useRef<HTMLInputElement>(null); // Tipagem mais precisa para ref

  //const homenetwork = homenetwork;

  let thisNetwork = homenetwork; 
  
  //bsv.Networks.testnet

  if(txidParams?.length === 64)
  {

    if(netParams === "test" )
      thisNetwork = bsv.Networks.testnet
    else
      thisNetwork = bsv.Networks.mainnet;

  }



  console.log("thisNet: ", thisNetwork)
  console.log("netParams: ", netParams)

  const downloadBinaryFile = () => {
    const blob = new Blob([binaryData.slice()]);
    console.log("File Size: ", binaryData?.byteLength);
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "fileS2P-" + currentTxid + "." + fileType;
    a.click();
    URL.revokeObjectURL(url);
    a.remove();
  };

  const readFromChain = async (inputTxid?: string) => { // Use inputTxid
    setdownloadFile(false);
    settokenInfo("");
    settokenOwner("");
    setwaitAlert(t('viewtoken.waiting'));

    let provider = new DefaultProvider({ network: thisNetwork });
    // await provider.connect(); // Removi o await pois não é necessário para inicializar o provider

    let tx3 = new bsv.Transaction();

    // Priorize o TXID vindo da URL ou de outro argumento
    let txidToUse = inputTxid || txIdRet.current?.value; // Use ?.value para segurança

    // Validação inicial do TXID
    if (!txidToUse || (txidToUse.length !== 64 && !hexStrFileData)) {
      setwaitAlert(t('viewtoken.invalidId'));
      setdownloadFile(false);
      settokenInfo("");
      settokenOwner("");
      return; // Saia da função se não houver dados válidos
    }

    try {
      if (txidToUse.length === 64) {
        // Obtenha a transação da rede
        const transactionData = await getTransaction(txidToUse, thisNetwork);
        if (!transactionData) {
          setwaitAlert(t('viewtoken.notFound'));
          setdownloadFile(false);
          settokenInfo("");
          settokenOwner("");
          return;
        }
        tx3 = new bsv.Transaction(transactionData);
        settxidFlag(txidToUse);
      } else {
        // Se não for um TXID de 64 caracteres, assuma que é uma string hexadecimal da transação
        if (!hexStrFileData || hexStrFileData.trim() === '') {
            setwaitAlert(t('viewtoken.emptyHex'));
            setdownloadFile(false);
            settokenInfo("");
            settokenOwner("");
            return;
        }
        tx3.fromString(hexStrFileData);
        txidToUse = tx3.id; // Obtenha o TXID da transação parseada
        settxidFlag("");
      }

      setcurrentTxid(txidParams ? txidParams : txidToUse as string);
      console.log("Test TX3 ID: ", tx3.id);

      // O resto da sua lógica de parsing da transação...
      let dataTX = toHex(tx3.outputs[0].script.toHex());
      let getData = tx3.outputs[0].script.toHex();
      let getDataASM = tx3.outputs[0].script.toASM();

      console.log("Script Hash: ", hexToLittleEndian(sha256(getData)));

      let timestamper = 0;
      let scriptHistoty = await scriptHistory(
        hexToLittleEndian(sha256(getData)),
        thisNetwork
      );

      console.log("Token Script Hash: ", hexToLittleEndian(sha256(getData)));

      for (let i = 0; i < scriptHistoty.length; i++) {
        console.log("Script Hash TXs: ", scriptHistoty[i].txId);
        console.log("Script Hash Block: ", scriptHistoty[i].height);
        if (scriptHistoty[i].txId === tx3.id) {
          timestamper = scriptHistoty[i].height;
          break;
        }
      }

      if (thisNetwork === bsv.Networks.testnet) {
        settxStamp(timestamper.toString(10) + "-TestNet");
      } else {
        settxStamp(timestamper.toString(10) + "-MainNet");
      }

      let index: number = getDataASM.indexOf("OP_RETURN");
      let fileType = "";
      let tokenType = false;
      let defaultData = false;

      let index0: number = getDataASM.indexOf("OP_1 0");

      if (index0 !== -1) {
        let index: number = getDataASM.indexOf("OP_1 0");
        getData = getDataASM.substring(
          index + "OP_1 0".length + 1,
          getDataASM.length
        );
        index = getData.indexOf(" ");
        let ownerpubKey = getData.substring(0, index);

        let pubKeySend = bsv.PublicKey.fromHex(ownerpubKey);
        let ownerAdd;

        if (ownerpubKey.length >= 66) {
          ownerAdd = bsv.Address.fromPublicKey(pubKeySend, thisNetwork);
        } else {
          ownerAdd = "none";
        }
        settokenOwner("Owner Add: " + ownerAdd);

        let stxos = await getSpentOutput(txidToUse, 0, thisNetwork); // Use txidToUse

        let tokenStateSC = "Current";
        if (stxos[0]?.inputIndex !== -1) { // Adicionado ?. para segurança
          tokenStateSC = "Past";
          settokenSale("");
        }

        tokenType = true;
        settokenInfo(
          "Opt Stamps Token: ( BALANCE = " +
            tx3.outputs[0].satoshis +
            " satoshi" +
            "; STATE = " +
            tokenStateSC +
            "; STAMP = " +
            timestamper +
            " )"
        );
      } else {
        let indexHahs1 = getData.indexOf("76a914");
        let indexHahs2 = getData.indexOf("88ac");

        let ownerAdd;
        if (
          indexHahs1 !== -1 &&
          indexHahs2 !== -1 &&
          indexHahs2 - (indexHahs1 + 6) === 40
        ) {
          ownerAdd = bsv.Address.fromPublicKeyHash(
            Buffer.from(getData.substring(indexHahs1 + 6, indexHahs2), "hex"),
            thisNetwork
          );
        } else {
          ownerAdd = "none";
        }
        settokenOwner("Owner Add: " + ownerAdd);

        let stxos = await getSpentOutput(txidToUse, 0, thisNetwork); // Use txidToUse

        let tokenStateSC = "Current";
        if (stxos[0]?.inputIndex !== -1) { // Adicionado ?. para segurança
          tokenStateSC = "Past";
          settokenSale("");
        }

        if (index !== -1) {
          tokenType = true;
          getData = getDataASM.substring(index + 10, getDataASM.length);
          settokenInfo(
            "p2pkh Return Data Token: ( BALANCE = " +
              tx3.outputs[0].satoshis +
              " sats" +
              "; STATE = " +
              tokenStateSC +
              "; STAMP = " +
              timestamper +
              " )"
          );
        } else {
          index = getDataASM.indexOf("0 OP_IF");
          if (index === -1) index = getDataASM.indexOf("OP_0 OP_IF");
          
          if (index !== -1) {
            if (tx3.outputs[0].satoshis === 1) {
              settokenInfo(
                "1satOrdinals Token: ( BALANCE = " +
                  tx3.outputs[0].satoshis +
                  " sat" +
                  "; STATE = " +
                  tokenStateSC +
                  "; STAMP = " +
                  timestamper +
                  " )"
              );
            } else {
              settokenInfo(
                "nSatOrdinals Token: ( BALANCE = " +
                  tx3.outputs[0].satoshis +
                  " sats" +
                  "; STATE = " +
                  tokenStateSC +
                  "; STAMP = " +
                  timestamper +
                  " )"
              );
            }

            let ordPayload = getDataASM.substring(index);
            let parts = ordPayload.split(" ");
            let dataType = "";
            let dataChunks: string[] = [];

            if (parts.length > 5) {
                dataType = parts[4];
                
                let dataStartIndex = 5;
                if (parts[5] === "OP_0" || parts[5] === "0") {
                    dataStartIndex = 6;
                }
                
                for (let i = dataStartIndex; i < parts.length; i++) {
                    if (parts[i] === "OP_ENDIF") break;
                    dataChunks.push(parts[i]);
                }
            }

            for (let i = 0; i < RetContentType.length; i++) {
              if (
                Buffer.from(dataType, "hex").toString("utf-8") ===
                RetContentType[i]
              ) {
                fileType = RetContentType[i + 1];
                break;
              }
            }
            getData = dataChunks.join("");
          } else {
            index = getDataASM.indexOf("OP_CHECKSIG");
            getData = getDataASM.substring(index + 12, getDataASM.length - 8);
            tokenType = true;
            settokenInfo(
              "p2pkh Data Drop Token: ( BALANCE = " +
                tx3.outputs[0].satoshis +
                " satoshi" +
                "; STATE = " +
                tokenStateSC +
                "; STAMP = " +
                timestamper +
                " )"
            );
          }
        }
      }

      dataTX = getData.replace(/\s/g, '');

      if (fileType.length === 0) {
        fileType = dataTX.substring(dataTX.length - 16, dataTX.length - 10);
      }

      let fTypeData = fileTypeFromData(fileType);
      let finalFileType = fTypeData[0];
      defaultData = fTypeData[1];

      const encoder = new TextEncoder();
      let bytes = hexToBytes(dataTX.substring(0, dataTX.length));

      if (tokenType && !defaultData) {
        bytes = hexToBytes(dataTX.substring(0, dataTX.length - 16));
      }

      let decodedStr = new TextDecoder("utf-8").decode(bytes);

      if (tokenType || defaultData) {
        if (decodedStr.trim().startsWith("{") || decodedStr.trim().startsWith("[")) {
          try {
            JSON.parse(decodedStr);
            finalFileType = "json";
            defaultData = false;
          } catch(e) {}
        } else if (bytes.length > 4 && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47) {
          finalFileType = "png";
          defaultData = false;
        } else if (bytes.length > 2 && bytes[0] === 0xff && bytes[1] === 0xd8) {
          finalFileType = "jpg";
          defaultData = false;
        } else if (bytes.length > 4 && bytes[0] === 0x47 && bytes[1] === 0x49 && bytes[2] === 0x46 && bytes[3] === 0x38) {
          finalFileType = "gif";
          defaultData = false;
        }
      }

      setfileType(finalFileType);
      setbinaryData(bytes);
      let bytesTX = hexToBytes(toHex(tx3));
      setbinaryDataTX(bytesTX);

      setstrData(decodedStr);

      // As variáveis imageBlob, imageUrl, htmlDataP, videoBlob, videoUrl
      // devem ser atualizadas *após* setbinaryData
      // ou serem definidas dentro do bloco de renderização (return)
      // para garantir que usem o `binaryData` mais recente.
      // Ou use um useEffect para elas.

      if (bytes.length > 0) {
        setdownloadFile(true);
        setwaitAlert("");
      } else if (bytes.length === 0) {
        setdownloadFile(true);
        setwaitAlert(t('viewtoken.noData'));
      } else {
        setwaitAlert(t('viewtoken.tryAgain'));
        settokenInfo("");
        settokenOwner("");
      }

    } catch (error) {
      console.error("Erro ao ler dados da cadeia:", error);
      setwaitAlert(t('viewtoken.errorProcessing'));
      setdownloadFile(false);
      settokenInfo("");
      settokenOwner("");
    }
  };

  useEffect(() => {
    // Quando txidParams muda (ex: na montagem se vier na URL)
    if (txidParams) {
      // Definir o valor do TextField se ele estiver disponível
      if (txIdRet.current) {
        txIdRet.current.value = txidParams;
      }
      readFromChain(txidParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [txidParams]); // Dependência: txidParams


  // Recriar URLs e dados do Blob sempre que binaryData mudar
  useEffect(() => {
    if (!binaryData || binaryData.length === 0) return;

    const imageBlob_loc = new Blob([binaryData.slice()], { type: "image/jpeg" });
    const imageUrl_loc = URL.createObjectURL(imageBlob_loc);
    const htmlDataP_loc = new TextDecoder("utf-8").decode(binaryData);
    const videoBlob_loc = new Blob([binaryData.slice()], { type: "video/mp4" });
    const videoUrl_loc = URL.createObjectURL(videoBlob_loc);

    setImageUrl(imageUrl_loc);
    setHtmlDataP(htmlDataP_loc);
    setVideoUrl(videoUrl_loc);

    // Revogar URLs antigas para evitar vazamento de memória
    return () => {
      URL.revokeObjectURL(imageUrl_loc);
      URL.revokeObjectURL(videoUrl_loc);
    };
  }, [binaryData]); // Dependência: binaryData


  // Importante: No evento de clique do botão, chame readFromChain sem argumentos
  // para que ele use o valor do TextField (txIdRet.current.value)
  const handleViewButtonClick = () => {
    readFromChain(); // Sem argumento, ele usará txIdRet.current.value
  };


  return (
    <Box sx={ViewTokenDataStyle.main} >
      <Typography variant='h1' style={ViewTokenDataStyle.h1}>
        {t('viewtoken.title')}
      </Typography>
      <Box sx={ViewTokenDataStyle.tokenSection} >
        <Box
          className="label-container"
          sx={ViewTokenDataStyle.inputIdContainer} >
          <Typography variant='body1' className="responsive-label" style={ViewTokenDataStyle.inputIdLabel}>
            {t('viewtoken.pasteId')}
          </Typography>
        </Box>
        <Box sx={ViewTokenDataStyle.inputContainer}>
          <TextField
            inputRef={txIdRet}
            type="text"
            name="PVTKEY1"
            placeholder={t('viewtoken.idPlaceholder')}
            variant="outlined"
            fullWidth
            sx={{
              '& .MuiOutlinedInput-root': ViewTokenDataStyle.inputIdTextEdit,
              '& .MuiInputLabel-root': ViewTokenDataStyle.inputIdTextEdit,
            }}
          />
        </Box>
      </Box>

      <Box>
      <Box sx={ViewTokenDataStyle.inputContainer}>
          <CustomButton onClick={handleViewButtonClick} buttonNane={t('viewtoken.viewButton')} />
        </Box>
      </Box>

      {downloadFile ? (
        fileType === "json" ? (
          <Box sx={ViewTokenDataStyle.containerStyle}>
            <p style={ViewTokenDataStyle.foundDataLabel}>
              {t('viewtoken.dataFoundJSON')}
            </p>
            <Box sx={{ overflowX: 'auto', bgcolor: 'background.paper', borderRadius: 1, p: 2, border: '1px solid #ccc' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                <tbody>
                  {(() => {
                    try {
                      const parsed = JSON.parse(strData);
                      return Object.entries(parsed).map(([key, value]) => (
                        <tr key={key} style={{ borderBottom: '1px solid #eee' }}>
                          <td style={{ padding: '8px', fontWeight: 'bold', width: '30%', verticalAlign: 'top', color: '#333' }}>{key}</td>
                          <td style={{ padding: '8px', wordBreak: 'break-all', color: '#555' }}>
                            {typeof value === 'object' ? <pre style={{margin: 0}}>{JSON.stringify(value, null, 2)}</pre> : String(value)}
                          </td>
                        </tr>
                      ));
                    } catch (e) {
                      return <tr><td colSpan={2} style={{color: 'red'}}>{t('viewtoken.jsonParseError')}{strData}</td></tr>;
                    }
                  })()}
                </tbody>
              </table>
            </Box>
          </Box>
        ) : fileType === "txt" || fileType === "csv" ? (
          <div>
            <h1 style={ViewTokenDataStyle.foundData}>
              {t('viewtoken.dataFound')}
            </h1>
            <iframe srcDoc={strData} style={ViewTokenDataStyle.fileFrame}
              title="File Presentation"
              allowFullScreen
            ></iframe>
          </div>
        ) : fileType === "png" ||
          fileType === "jfif" ||
          fileType === "jpg" ||
          fileType === "jpeg" ||
          fileType === "webp" ||
          fileType === "bmp" ? (
          <Box sx={ViewTokenDataStyle.containerStyle}>
            <p style={ViewTokenDataStyle.foundDataLabel} >
              {t('viewtoken.dataFound2')}
            </p>
            <img src={imageUrl} alt="Imagem" style={ViewTokenDataStyle.imageStyle} />
          </Box>
        ) : fileType === "html" || fileType === "webp" ? ( // Note: webp can be image or html? Seems inconsistent
          <Box sx={ViewTokenDataStyle.containerStyle}>
            <p style={ViewTokenDataStyle.foundDataLabel} >
              {t('viewtoken.dataFound')}
            </p>
            <iframe
              srcDoc={htmlDataP}
              title="HTML File"
              style={ViewTokenDataStyle.imageStyle}
            ></iframe>
          </Box>
        ) : fileType === "mp4" ? (
          <div style={ViewTokenDataStyle.containerStyleV}>
            <p style={ViewTokenDataStyle.foundDataLabel}>
              {t('viewtoken.dataFound')}
            </p>
            <video controls style={ViewTokenDataStyle.videoStyle}>
              <source src={videoUrl} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        ) : fileType === "wmv" ? ( // WMV video files typically need more specific handling, often not natively supported by <video> tag
          <div style={ViewTokenDataStyle.containerStyleV}>
            <p style={ViewTokenDataStyle.foundDataLabel}>
              {t('viewtoken.dataFoundWMV')}
            </p>
          </div>
        ) : ( // Fallback for other file types
          <div>
            <p style={ViewTokenDataStyle.foundDataLabel} >
              {t('viewtoken.dataFound')}
            </p>
            <iframe
              srcDoc={
                t('viewtoken.unsupportedFile')
              }
              title={`Unsupported File - ${fileType}`}
              style={ViewTokenDataStyle.fileFrame}
              allowFullScreen
            ></iframe>
          </div>
        )
      ) : (
        ""
      )}

      {downloadFile ? (
        <div>
          <Box sx={ViewTokenDataStyle.downloadContainer} >
            <CustomButton onClick={downloadBinaryFile} buttonNane={t('viewtoken.downloadData')} />
          </Box>
        </div>
      ) : (
        ""
      )}

      {waitAlert === "" ? (
          <div></div>
        ) : (
          <div
            className="label-container"
            style={ViewTokenDataStyle.foundDataLabel} >
            <p className="responsive-label" style={ViewTokenDataStyle.alertLabel}>
              {waitAlert}{" "}
            </p>
          </div>
        )
      }
    </Box>
  );
};

export default ViewTokenData;